import React from "react";
import { COMPONENT_IDS } from "../../helpers/constants/componentIds";
import { MuiTypography } from "../typography/MuiTypography";
import { AccordionHeaderTextWrapper } from "./AccordionHeader.style";

interface AccordionHeaderTextProps {
  label: string | React.ReactNode;
}

export const AccordionHeaderText: React.FC<AccordionHeaderTextProps> = ({
  label,
}) => {
  return (
    <AccordionHeaderTextWrapper className="accordion-header-text">
      <MuiTypography
        id={`${COMPONENT_IDS.COMMON_ACCORDION_HEADER_TEXT}-${label}`}
        variant="h2SemiBold"
        className="accordion-header-form-header-left"
        component={"h2"}
      >
        {label}
      </MuiTypography>
    </AccordionHeaderTextWrapper>
  );
};
